import request from '@/utils/request'

// 策略列表
export function getStrategyCategoryList(params) {
  return request({
    url: '/adx/strategy/condition',
    method: 'get',
    params
  })
}
// 新增策略
export function strategyCreate(data = {}) {
  return request({
    url: '/adx/strategy/create',
    method: 'post',
    data
  })
}
// 修改策略
export function strategyUpdate(data = {}) {
  return request({
    url: '/adx/strategy/update',
    method: 'post',
    data
  })
}
// 删除策略
export function strategyDelete(data = {}) {
  return request({
    url: '/adx/strategy/delete',
    method: 'post',
    data
  })
}

// 策略列表
export function strategyList(params) {
  return request({
    url: '/adx/strategy/list',
    method: 'get',
    params
  })
}
// 短剧列表
export function playLetList(params) {
  return request({
    url: '/adx/strategy/play_let_list',
    method: 'get',
    params
  })
}

// 素材策略详情列表
export function materialInfoList(params) {
  return request({
    url: '/adx/strategy/material_list',
    method: 'get',
    params
  })
}
// 策略-更多素材
export function moreMaterialInfoList(params) {
  return request({
    url: '/adx/strategy/more_material_list',
    method: 'get',
    params
  })
}
// 素材策略条件列表
export function condition(params) {
  return request({
    url: '/adx/strategy/condition',
    method: 'get',
    params
  })
}

// 素材条件列表
export function categoryList(params) {
  return request({
    url: '/adx/material/year_month',
    method: 'get',
    params
  })
}
// 策略素材列表
export function materialList(params) {
  return request({
    url: '/adx/material/list',
    method: 'get',
    params
  })
}

// 素材上传
export function uploadMaterial(data = {}) {
  return request({
    url: '/adx/material/upload',
    method: 'post',
    data
  })
}
// 策略开关
export function strategyStop(data = {}) {
  return request({
    url: '/adx/strategy/stop',
    method: 'post',
    data
  })
}

// 素材详情
export function clickPreview(data = {}) {
  return request({
    url: '/adx/material/click_preview',
    method: 'post',
    data
  })
}
// 账号列表
export function adxaccountlist(params) {
  return request({
    url: '/adx/account/list',
    method: 'get',
    params
  })
}
// 账号创建
export function adxaccountcreate(data = {}) {
  return request({
    url: '/adx/account/create',
    method: 'post',
    data
  })
}
// 账号修改
export function adxaccountupdate(data = {}) {
  return request({
    url: '/adx/account/update',
    method: 'post',
    data
  })
}
// 账号删除
export function adxaccountdel(data = {}) {
  return request({
    url: '/adx/account/del',
    method: 'post',
    data
  })
}
// 查询素材的信息
export function adxpreviewinfo(params) {
  return request({
    url: '/adx/material/preview_info',
    method: 'get',
    params
  })
}
// 查询素材的信息(如果没有素材 在调用这个)
export function adxrclickpreview(data = {}) {
  return request({
    url: '/adx/material/click_preview',
    method: 'post',
    data
  })
}
// 账号列表
export function adxaccountlistbianse(params) {
  return request({
    url: '/adx/orderId/list',
    method: 'get',
    params
  })
}
// 账号创建
export function adxaccountcreatebianse(data = {}) {
  return request({
    url: '/adx/orderId/create',
    method: 'post',
    data
  })
}
// 账号修改
export function adxaccountupdatebianse(data = {}) {
  return request({
    url: '/adx/orderId/update',
    method: 'post',
    data
  })
}
// 账号删除
export function adxaccountdelbianse(data = {}) {
  return request({
    url: '/adx/orderId/del',
    method: 'post',
    data
  })
}
// 自动创建规则列表
export function createadconfiglist(params) {
  return request({
    url: '/adx/create_ad_config/list',
    method: 'get',
    params
  })
}
// 自动创建规则列表
export function createAdSwitch(data = {}) {
  return request({
    url: '/adx/create_ad_config/switch',
    method: 'post',
    data
  })
}
// 新增自动创建规则
export function createadconfigcreate(data = {}) {
  return request({
    url: '/adx/create_ad_config/create',
    method: 'post',
    data
  })
}
// 修改自动创建规则
export function createadconfigupdate(data = {}) {
  return request({
    url: '/adx/create_ad_config/update',
    method: 'post',
    data
  })
}
// 删除自动创建规则
export function createadconfigdel(data = {}) {
  return request({
    url: '/adx/create_ad_config/del',
    method: 'post',
    data
  })
}
// 自动创建记录
export function createadrecordlist(params) {
  return request({
    url: '/adx/create_ad_record/list',
    method: 'get',
    params
  })
}
// 批次列表
export function adxbulklist(params) {
  return request({
    url: '/adx/bulk/list',
    method: 'get',
    params
  })
}
// 下拉筛选1
export function playletaccountlistonewqww(params) {
  return request({
    url: '/changdu/playlet/account/list',
    method: 'get',
    params
  })
}
// 抖音链接列表
export function novelLink(params) {
  return request({
    url: '/tiktok/novelLink/index',
    method: 'get',
    params
  })
}
// 下拉筛选2
export function playletaccountlisttwo(params) {
  return request({
    url: '/changdu/playlet/app/list',
    method: 'get',
    params
  })
}
// 下拉筛选3
export function playletaccountlistthree(params) {
  return request({
    url: '/changdu/playlet/channel/list',
    method: 'get',
    params
  })
}

// 抖音链接创建
export function createNovelLink(data = {}) {
  return request({
    url: '/tiktok/novelLink/create',
    method: 'post',
    data
  })
}
// 抖音链接全部修改状态 “正在获取中” 改成 失败
export function updateAll(data = {}) {
  return request({
    url: '/tiktok/novelLink/failure',
    method: 'post',
    data
  })
}
// 抖音链接更新
export function updateNovelLink(data = {}) {
  return request({
    url: '/tiktok/novelLink/update',
    method: 'post',
    data
  })
}
// 抖音链接删除
export function delNovelLink(data = {}) {
  return request({
    url: '/tiktok/novelLink/destroy',
    method: 'post',
    data
  })
}
// 导出数据
export function exportNovelLink(data = {}) {
  return request({
    url: '/tiktok/novelLink/export',
    method: 'post',
    data
  })
}
// 抖音文件批量上传
export function importMoreLink(data = {}) {
  return request({
    url: '/tiktok/novelLink/import',
    method: 'post',
    data
  })
}

// 广告链接列表
export function adElementList(params) {
  return request({
    url: '/tiktok/ad_element/index',
    method: 'get',
    params
  })
}
// 广告链接新增
export function adElementCreate(data = {}) {
  return request({
    url: '/tiktok/ad_element/create',
    method: 'post',
    data
  })
}
// 广告链接修改
export function adElementUpdate(data = {}) {
  return request({
    url: '/tiktok/ad_element/update',
    method: 'post',
    data
  })
}
// 广告链接删除
export function adElDel(data = {}) {
  return request({
    url: '/tiktok/ad_element/destroy',
    method: 'post',
    data
  })
}
// 本地素材列表
export function LocalVideoList(params) {
  return request({
    url: '/adx/local_video/list',
    method: 'get',
    params
  })
}
// 新增本地素材
export function localVideoAdd(data = {}) {
  return request({
    url: '/adx/local_video/create',
    method: 'post',
    data
  })
}
// 发送素材
export function uploadMat(data = {}) {
  return request({
    url: '/adx/local_video/upload',
    method: 'post',
    data
  })
}
// 发送素材
export function uploadcertrr(data = {}) {
  return request({
    url: '/tiktok/novelLink/importComplete',
    method: 'post',
    data,
    isUpload: true
  })
}

export function importAnalysisPlaylet(data = {}) {
  return request({
    url: '/tiktok/novelLink/importAnalysisPlaylet',
    method: 'post',
    data
  })
}

